import { reducer as user } from './user';
import { reducer as nav } from './nav';
import { reducer as loading } from './loading';
import { reducer as error } from './error';
import { reducer as brand } from './brand';
import { reducer as auth } from './auth';

export default {
  user,
  nav,
  loading,
  error,
  brand,
  auth,
};
